<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 550.801 550.801"
  style="enable-background: new 0 0 550.801 550.801"
  xml:space="preserve"
>
  <g>
    <path
      d="M280.821,252.316c-7.414,0-12.44,0.712-15.077,1.426v47.625c3.117,0.717,6.945,0.959,12.206,0.959
		c19.388,0,31.348-9.813,31.348-26.324C309.298,261.167,299.01,252.316,280.821,252.316z"
    />
    <path
      d="M170.245,276.002c0-14.835-10.28-23.686-28.468-23.686c-7.412,0-12.44,0.712-15.077,1.426v47.625
		c3.116,0.717,6.95,0.959,12.205,0.959C158.291,302.326,170.245,292.513,170.245,276.002z"
    />
    <path
      d="M488.426,197.019H475.2v-63.816c0-0.398-0.063-0.799-0.116-1.202c-0.021-2.534-0.827-5.023-2.562-6.995L366.325,3.694
		c-0.032-0.031-0.063-0.042-0.085-0.076c-0.633-0.707-1.371-1.295-2.151-1.804c-0.231-0.155-0.464-0.285-0.706-0.419
		c-0.676-0.369-1.393-0.675-2.131-0.896c-0.2-0.056-0.38-0.138-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
		c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.873v160.545
		c0,17.043,13.824,30.87,30.873,30.87h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
		V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87v-160.54C519.297,210.838,505.47,197.019,488.426,197.019z M97.2,21.605
		h250.193v110.513c0,5.967,4.841,10.8,10.8,10.8h95.407v54.108H97.2V21.605z M345.432,275.044c0,15.796-5.263,29.191-14.829,38.283
		c-12.456,11.718-30.881,16.991-52.421,16.991c-4.78,0-9.088-0.248-12.437-0.718v57.671h-36.136V228.14
		c11.248-1.911,27.05-3.354,49.302-3.354c22.488,0,38.524,4.311,49.288,12.928C338.492,245.854,345.432,259.25,345.432,275.044z
		 M90.563,387.271V228.14c11.249-1.911,27.05-3.354,49.302-3.354c22.491,0,38.525,4.311,49.288,12.928
		c10.296,8.14,17.231,21.537,17.231,37.331c0,15.796-5.26,29.191-14.829,38.283c-12.454,11.723-30.879,16.991-52.418,16.991
		c-4.781,0-9.089-0.248-12.443-0.718v57.671H90.563z M453.601,523.353H97.2V419.302h356.4V523.353z M480.41,256.619h-44.033v130.652
		H399.77V256.619h-43.316v-30.628H480.41V256.619z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
